import { CommonModule } from '@angular/common';
import { Component, ViewChild, inject } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { SnackBarFacade } from '@ra-state';
import {
  IToastConfig,
  NotificationType,
  OverlayPosition,
  RaUiToastModule,
  ToastDirective,
} from '@ra-web-tech-ui-toolkit/components';
import { tap } from 'rxjs';
@Component({
  selector: 'app-snackbar',
  styleUrls: ['./snackbar.component.scss'],
  templateUrl: './snackbar.component.html',

  imports: [CommonModule, RaUiToastModule, RouterModule],
})
export class SnackBarComponent {
  private readonly snackbarFacade = inject(SnackBarFacade);
  router = inject(Router);

  navigateTo: string;
  @ViewChild(ToastDirective, { static: true }) public toastRef: ToastDirective;
  public toastConfig: IToastConfig = {
    delay: 7000,
    position: OverlayPosition['TopRight'],
  };

  displayMessage$ = this.snackbarFacade.displayMessage$.pipe(
    tap((data) => {
      if (data) {
        const title = data.title || '';
        const type = data.type || 'Success';
        this.toastRef.buttons = data.customBtn ?? [];
        this.toastRef.addToast(String(data?.message), NotificationType[type], title);
      }
    }),
  );

  btnClick($event): void {
    if ($event.button.label === 'Download') {
      window.open($event.button.navigateTo, '_self');
      return;
    }
    if ($event.button.openInNewTab) {
      window.open($event.button.navigateTo, '_blank', 'noopener,noreferrer');
      return;
    }
    this.router.navigate([$event.button.navigateTo]);
  }
}
